
import { PopupIds } from '../../constants/PopupIds';
import {isValidEmail} from './validators';
import { Browsers } from '../../constants/Browsers';
import { callserver } from './callserver';
import { Localization } from '../../localization/localization';
import { container } from "../../utils/container/container";
import { FeatureFlagsLoader } from "../../utils/feature-flags/feature-flags-loader";
import { ServiceIds } from "../../utils/container/service-ids";
import { FlagNames } from "../../utils/feature-flags/flag-names";

let $container: JQuery = null;

function sendHandler() {
    const $input = $('input[type=email]', $container);
    const $parent = $input.parent();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const email: any = $input.val();
    const $this = $(this);

    $parent.removeClass('error');

    if (!isValidEmail(email)) {
        $parent.addClass('error');
        return;
    }

    sendEmail(email, $this);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sendEmail(email: string, $this: any) {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const flag = ffLoader.get(FlagNames.SEND_DOWNLOAD_CLIENT_EMAIL_NO_DUPLICATES);
    if (flag.isOn()) {
        return;
    }

    const $loadingScreen = $('#download_client_screen_loading');

    $this.off('click.send');
    $loadingScreen.show();

    callserver('sendDownloadClientEmail', {
        email: email
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, function(response: any) {
        if (response.result && response.result === 1) {
            $loadingScreen.hide();
            $('#download_client_screen_buttons').hide();
            $('#download_client_step').hide();
            $('.download_client_success').show()
                .text(Localization._n('download_email.success', {email: email}));
        } else {
            console.error(response);
            $this.on('click.send', sendHandler);
        }
    });
}

function WhereIsDownload() {
    try {
        const myBrowserName = window.app.config.user_browser.name.toLowerCase();
        const isChrome = myBrowserName == Browsers.CHROME;

        if (isChrome) {
            $('.arrow_promt_download').show();
        } else {
            $('.arrow_promt_download').addClass('top_arrow_promt_download')
                .show();
        }
        setTimeout(()=>{ $('.arrow_promt_download').hide(); }, 8000);
    } catch (ex) {
        console.log(`Uh, it's error: ${ex}`);
    }
}
$(function() {
    $('#js-download_button').on('click', function() {
        window.app.game_popup_close();
        window.app.game_popup(PopupIds.DOWNLOAD_CLIENT_POPUP);
    });

    $('#download_client_popup .js-close-button').on('click', function() {
        window.app.game_popup_close();
    });

    /* - -*/
    $container = $('#download_client_screen');

    if (window.app.session.email) {
        $('.download_icon_button.download', $container).on('click', function() {
            sendEmail(window.app.session.email as string, $(this));
        });
    } else {
        $('.js-close-button', $container).on('click', function() {
            $('#download_client_screen_buttons').show();
            $('#download_client_step').hide();
        });

        $('.download_icon_button.download', $container).on('click', function() {
            $('#download_client_screen_buttons').hide();
            $('#download_client_step').show();
        });

        $('.js-send', $container).on('click.send', sendHandler);
    }

    $('.download_icon_button.download, .download_desktop, .download_desktop_yb').click(function() {
        /* Прячем окно с кнопками загрузки */
        window.app.game_popup_close();
        /* Показываем промт со стрелкой в зависимости от бровзера */
        WhereIsDownload();
    });
});
